import { Progress } from '@/components/ui/progress';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentContext';

export function AnlageassistentProgressbar() {
  const { ctx } = useAnlageassistentContext();

  return (
    <Progress
      value={ctx.currentStepProgress()}
      className="w-full h-2 rounded-none md:rounded-full"
    />
  );
}
